export default class PlaymakerTypes {
  static number10 = "NUMBER_10";
  static targetMan = "TARGET_MAN";
}
